import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ fontFamily:'monospace', padding:40, color:'#dc2626', background:'#fff' }}>
          <h2>App Error</h2>
          <pre style={{ whiteSpace:'pre-wrap', fontSize:13 }}>{this.state.error?.message}</pre>
          <pre style={{ whiteSpace:'pre-wrap', fontSize:11, color:'#666' }}>{this.state.error?.stack}</pre>
          <button onClick={() => window.location.reload()} style={{ marginTop:20, padding:'8px 16px', cursor:'pointer' }}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
